import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'
import { withRouter } from 'react-router-dom'
import { Box, Button } from '@material-ui/core'
import { setLocale, getLocale } from 'utils/localstorage'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { auth as authModule } from 'redux/modules'

const LanguageToggle = ({ languages, setActiveLanguage, user, updateUser }) => {
  setLocale(getLocale())
  const [langs, setLangs] = useState(
    languages.map((p) => {
      const lang = { ...p }

      return {
        value: lang.code,
        title: lang.name,
        active: lang.code === getLocale(),
      }
    })
  )

  const updateLanguages = (tempLang) => {
    setLangs(
      langs.map((p) => {
        const lang = { ...p }
        if (lang.value === tempLang) {
          lang.active = true
        } else {
          lang.active = false
        }

        return lang
      })
    )
  }

  const handleLang = (code) => {
    setActiveLanguage(code)
    setLocale(code)

    updateLanguages(code)

    // Update user language
    updateUser(user.uuid, { language: code, preventToastNotification: true })
  }

  useEffect(() => {
    if (!user.language) {
      setActiveLanguage(getLocale())
    } else {
      setActiveLanguage(user.language)
    }

    updateLanguages(user.language)
  }, [user.language])

  return (
    <Box px={1.5} py={1.5} textAlign="center">
      {langs.map(({ value, title, active }) => {
        return (
          <Button
            variant={active ? 'contained' : 'text'}
            color={active ? 'primary' : 'default'}
            key={value}
            onClick={() => handleLang(value)}
            size="small"
          >
            {title}
          </Button>
        )
      })}
    </Box>
  )
}

LanguageToggle.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
    })
  ).isRequired,
  setActiveLanguage: PropTypes.func.isRequired,
  user: PropTypes.shape().isRequired,
  updateUser: PropTypes.func.isRequired,
}

export default compose(
  connect(
    ({ auth }) => ({
      user: auth.user,
    }),
    {
      updateUser: authModule.updateUser,
    }
  ),
  withLocalize,
  withRouter
)(LanguageToggle)
